import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface InsolvencySettingsState {
  professional_bodies: any
  reasons: any
  academic_qualifications: any
  professional_qualifications: any
  professional_body: any
  reason: any
  academic_qualification: any
  professional_qualification: any
  insolvency_error: any
  insolvencies: any
}

export const useInsolvencySettingsStore = defineStore('insolvencySettings', {
  state: (): InsolvencySettingsState => ({
    professional_bodies: null,
    reasons: null,
    academic_qualifications: null,
    professional_qualifications: null,
    professional_body: null,
    reason: null,
    academic_qualification: null,
    professional_qualification: null,
    insolvency_error: null,
    insolvencies: null,
  }),

  getters: {
    getProfessionalBodies: (state) => state.professional_bodies,
    getReasons: (state) => state.reasons,
    getAcademicQualifications: (state) => state.academic_qualifications,
    getProfessionalQualifications: (state) => state.professional_qualifications,
    getInsolvencyError: (state) => state.insolvency_error,
    getProfessionalBody: (state) => state.professional_body,
    getReason: (state) => state.reason,
    getAcademicQualification: (state) => state.academic_qualification,
    getProfessionalQualification: (state) => state.professional_qualification,
    getInsolvencySubmissions: (state) => state.insolvencies,
  },

  actions: {
    async fetchProfessionalBodies() {
      try {
        const response = await api().get('configuration/professional-body/all')
        this.professional_bodies = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async fetchReasons() {
      try {
        const response = await api().get('configuration/insolvency-reasons')
        this.reasons = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async fetchAllInsolvency(data: string) {
      try {
        const path = '/insolvency/process' + data
        const response = await api().get(path)
        this.insolvencies = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async fetchWindingDraftData(trackingNumber: string) {
      try {
        const response = await api().get('insolvency/winding-up/details?tracking-number=' + trackingNumber)
        // Note: Original code didn't commit this to state, keeping the same behavior
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async fetchAcademicQualifications() {
      try {
        const response = await api().get('configuration/academic-qualification/all')
        this.academic_qualifications = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async fetchProfessionalQualifications() {
      try {
        const response = await api().get('configuration/professional-qualification/all')
        this.professional_qualifications = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async createProfessionalBody(data: any) {
      try {
        const response = await api().post('configuration/professional-body/create', data)
        this.professional_body = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async createReason(data: any) {
      try {
        const response = await api().post('configuration/insolvency-reasons', data)
        this.reason = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async updateProfessionalBody(data: any) {
      try {
        const response = await api().post('configuration/professional-body/update', data)
        this.professional_body = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async createAcademicQualification(data: any) {
      try {
        const response = await api().post('configuration/academic-qualification/create', data)
        this.academic_qualification = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async updateAcademicQualification(data: any) {
      try {
        const response = await api().post('configuration/academic-qualification/update', data)
        this.academic_qualification = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async createProfessionalQualification(data: any) {
      try {
        const response = await api().post('configuration/professional-qualification/create', data)
        this.professional_qualification = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },

    async updateProfessionalQualification(data: any) {
      try {
        const response = await api().post('configuration/professional-qualification/update', data)
        this.professional_qualification = response.data
      } catch (error: any) {
        this.insolvency_error = error.response?.data
      }
    },
  },
})
